<template>
  <div id="_holacon_programs">
    <info-block :title="$getModuleTitle(currentEvent.modules, 'Program')" :desc="$t('networking.description')" :button="null" :url="null">
      <template slot="input">
        <div id="frame" style="overflow: hidden; width: 100%; box-shadow: none;">
          <div style="display: flex; align-items: center; justify-content: center; flex-direction: row;">
            <swiper :options="swiperOptions" :key="swiperKey" :instanceName="'customSwiperInstanceName'">
              <swiper-slide class="day tns-item" :class="activeDay == day.id ? 'active' : ''" v-for="(day, index) in currentProgramDays" :key="index" @click="activeDay = day.id" style="width: auto">
                <div @click="activeDay = day.id" style="padding: 10px 15px; display: block; display: flex; align-items: center; align-self: stretch; flex-direction: row; justify-content: center;">
                  <span class="title" @click="activeDay = day.id" :style="activeDay == day.id ? 'background-color :' + currentEvent.color + '; color: white;' : ''">
                    <span style="line-height: 10px;">
                      {{ moment(day.date).format("D") }}
                    </span>
                  </span>
                  <div @click="activeDay = day.id" style="display: flex; flex-direction: column; align-items: flex-start; justify-content: center; margin-top: 7px">
                    <span style="line-height: 13px;" @click="activeDay = day.id">
                      {{ day.title }}
                    </span>
                    <span class="day-title" @click="activeDay = day.id">
                      {{ moment(day.date).format("dddd") }}
                    </span>
                  </div>
                </div>
              </swiper-slide>
              <div slot="button-prev"></div>
              <div slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div class="program-header" :style="currentSubEvents.length == 0 && currentProgramSaloons.length == 0 ? 'grid-template-columns: 1fr !important;' : '' + currentSubEvents.length == 0 || currentProgramSaloons.length == 0 ? 'grid-template-columns: 2fr 1fr;' : 'grid-template-columns: 2fr 1fr 1fr;'">
          <div class="program-search">
            <el-input v-model="searchTerm" :placeholder="$t('search')" :loading="$store.state.eventLoading == 'program'" :suffix-icon="$store.state.eventLoading == 'program' ? 'el-icon-loading' : 'el-icon-search'" @clear="searchTerm = null" clearable></el-input>
          </div>
          <div class="program-select" v-if="currentSubEvents.length != 0">
            <el-select v-model="subEventID" @clear="subEventID = null" :placeholder="$t('sub_event_filter')" clearable>
              <el-option :key="index" :label="sub.title" :value="sub.id" v-for="(sub, index) in currentSubEvents">
                <template>
                  <i class="fas fa-circle" :style="'color:' + sub.color" style="margin-right:4px"></i>
                  <span>{{ sub.title }}</span>
                </template>
              </el-option>
            </el-select>
          </div>
          <div class="program-select" v-if="currentProgramSaloons.length != 0">
            <el-select v-model="saloonID" @clear="saloonID = null" :placeholder="$t('event.program.all_saloons')" clearable>
              <el-option :key="index" :label="saloon.title" :value="saloon.id" v-for="(saloon, index) in currentProgramSaloons">
                <template>
                  <i class="fas fa-circle" :style="'color:' + saloon.color" style="margin-right:4px"></i>
                  <span>{{ saloon.title }}</span>
                </template>
              </el-option>
            </el-select>
          </div>
        </div>
      </template>
    </info-block>

    <div v-if="subEventID != null" style="width: 100%; display: flex; padding: 10px 15px; background: #FF7511; margin-top: 8px; color: white; font-weight: 400; border-radius: 8px; font-family: Roboto, sans-serif;">
      <span style="flex: 1; display: flex">
        {{ $t("event.program.subevent_filter", { title: currentSubEvents.find(k => k.id == subEventID).title }) }}
      </span>
      <button style="background: none; border: none; outline: none; cursor: pointer;" @click="subEventID = null">
        <i class="fa fa-close" style="color: white"></i>
      </button>
    </div>

    <transition-group name="list-complete" tag="ul" id="_programs">
      <li v-for="item in getPrograms" @click="$store.dispatch('getProgram', item.id)" :key="item.id" class="_tile list-complete-item" :style="item.type == 2 ? 'background-color:' + currentEvent.color + '!important' : ''" :class="[item.type == 2 ? 'section' : '']">
        <div class="date">
          <i class="fas fa-clock" style="font-size:13px;" :style="item.type == 2 ? 'color: white;' : 'color:' + currentEvent.color + ';'"></i>
          <span>{{ getTime(item.startTime) }}</span>
          <i class="fas fa-long-arrow-alt-right"></i>
          <span>{{ getTime(item.endTime) }}</span>

          <template v-if="item.saloonID && currentProgramSaloons.find(x => x.id == item.saloonID)">
            <i class="fas fa-map-marker-alt" style="font-size:14px; margin-left: 10px" :style="'color:' + currentEvent.color + ';'"></i>
            <span @click="saloonID = item.saloonID" class="saloon-hover">{{ currentProgramSaloons.find(x => x.id == item.saloonID).title }}</span>
          </template>

          <span style="float: right; color: gray; line-height: 20px">
            {{ currentProgramDays.find(k => k.id == item.dayID).title }}
          </span>

          <vue-stars v-if="item.avgRate != 0 && item.avgRate != null" style="margin-left: 10px" :name="item.id" active-color="#ffdd00" inactive-color="#999999" shadow-color="#ffff00" hover-color="#dddd00" :max="5" :value="item.avgRate" :readonly="true" char="★" inactive-char class />
        </div>

        <template v-if="item.subEventID != null">
          <div @click.stop="subEventID = item.subEventID" v-if="currentSubEvents.find(k => k.id == item.subEventID)" style="display: inline-block; padding:3px 10px; color: white; border-radius: 4px;margin-bottom: 4px; margin-top: 4px; font-size: 14px; cursor: pointer" :style="'background-color:' + currentEvent.color + ';'">
            {{ currentSubEvents.find(k => k.id == item.subEventID).title }}
          </div>
        </template>

        <div class="title" style="cursor: pointer" @click="$store.dispatch('getProgram', item.id)">
          <span>
            <template v-if="item.type == 3 && item.badgeTitle != null && item.badgeTitle != ''"><i :class="item.badgeTitle" :style="'color:' + currentEvent.color" style="margin-right:6px;"></i></template>
            {{ item.title }}
          </span>
        </div>

        <template v-if="item.speakers.length > 0">
          <ul class="speakers">
            <div v-for="(speaker, index) in getSpeakers(item.id)" :key="speaker.id + '-item-' + item.id + '-index-' + index">
              <el-tooltip effect="dark" placement="top">
                <div slot="content" style="text-align:center">
                  <span>
                    <b>{{ speaker.fullName }}</b>
                  </span>
                  <br />
                  <span>
                    <template v-if="speaker.title">{{ speaker.title }}</template>
                    <b v-if="speaker.firmName">@ {{ speaker.firmName }}</b>
                  </span>
                </div>
                <li @click.stop="$store.dispatch('getSpeaker', speaker.id)" class="speaker-photo" :style="'background-image: url(' + $imageus + speaker.image + '?width=200&height=200&mode=cover);'"></li>
              </el-tooltip>
            </div>
          </ul>
        </template>
      </li>
    </transition-group>

    <Nodata :title="$getModuleTitle(currentEvent.modules, 'Program')" :description="subEventID == null && saloonID == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-programs-lottie" :loading="loading == 'refreshDay'" v-if="currentProgram.length == 0 || getPrograms.length == 0" :button="$t('refresh')" @btnClick="refresh" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import InfoBlock from "../../modules/InfoBlock.vue";

export default {
  name: "ProgramsComponent",
  props: {},
  components: {
    InfoBlock
  },
  data() {
    return {
      searchTerm: null,
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 0
      },
      swiperKey: +new Date(),
      moment,
      activeDay: null,
      subEventID: null,
      saloonID: null,
      timeout: null,
      loading: false
    };
  },
  mounted() {
    this.swiperKey++;
  },
  methods: {
    async searchFilter() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getPrograms", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.timeout = null;
      }, 500);
    },

    openImage(speaker) {
      $.fancybox.open({
        items: [speaker.image]
      });
    },

    getTime(time) {
      time = time.split(":");
      return moment()
        .set({ hours: time[0], minutes: time[1] })
        .format("HH:mm");
    },

    getSpeakers(id) {
      // Verilen ID'sine sahip programı bul
      var program = this.currentProgram.find(k => k.id == id);
      // Sonuç dizisi oluştur
      var result = [];
      // Programın konuşmacılarını döngüyle dolaş
      for (var i = 0; i < program.speakers.length; i++) {
        // Programın konuşmacısının bilgilerini bul
        var speaker = this.currentProgramSpeakers.find(x => x.id == program.speakers[i].speakerID);
        // Eğer konuşmacı bulunduysa, sonuç dizisine ekle
        if (speaker != null) {
          result.push(speaker);
          result = _.uniqWith(result, _.isEqual);
        }
      }
      // Sonuç dizisini döndür
      return result;
    },

    async refresh() {
      this.loading = "refreshDay";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.searchTerm = null;
        this.saloonID = null;
        this.subEventID = null;
        await this.$store.dispatch("getPrograms", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        this.loading = false;
      }, 500);
    }
  },

  async created() {
    // Programları getir ve mağazaya kaydet
    await this.$store.dispatch("getPrograms", { id: this.currentEvent.id, route: false });

    // Eğer program günleri mevcutsa, ilk günü aktif olarak ayarla
    if (this.currentProgramDays.length != 0) {
      this.activeDay = this.currentProgramDays[0].id;
    }

    // Eğer program günleri mevcut değilse, 1 saniye sonra tekrar kontrol et
    if (this.currentProgramDays.length == 0) {
      this.interval = setTimeout(() => {
        // Eğer program günleri mevcutsa, ilk günü aktif olarak ayarla ve zaman aşımını durdur
        if (this.currentProgramDays.length) {
          this.activeDay = this.currentProgramDays[0].id;
          clearInterval(this.interval);
          this.interval = null;
        }
      }, 1000);
    }
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentProgram() {
      return this.$store.getters.getPrograms;
    },
    currentProgramDays() {
      return this.$store.getters.getProgramDays;
    },
    currentProgramSaloons() {
      return this.$store.getters.getProgramSaloons;
    },
    currentProgramSpeakers() {
      return this.$store.getters.getProgramSpeakers;
    },
    currentSubEvents() {
      return this.$store.getters.getSubEvents;
    },
    getPrograms() {
      var data = this.currentProgram;
      data = data.filter(k => k.dayID == this.activeDay);
      if (this.subEventID != null) {
        data = data.filter(k => k.subEventID == this.subEventID);
      }
      if (this.saloonID != null) {
        data = data.filter(k => k.saloonID == this.saloonID);
      }
      return data;
    }
  },
  watch: {
    searchTerm: async function() {
      await this.searchFilter();
    }
  }
};
</script>

<style>
.modal-vue-wrapper {
  z-index: 999999;
}
.modal-vue--content-panel.space-content {
  padding-top: 5px;
  padding-bottom: 10px;
  width: 100%;
}
.modal-vue-panel::-webkit-scrollbar-thumb {
  background-color: gray !important;
}

.modal-vue--content-panel {
  display: block;
  text-align: left;
  font-size: 16px;
  flex-grow: 1;
}

.list-complete-item {
  transition: all 0.4s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-144px);
}
.list-complete-leave-active {
  position: absolute;
}

pre {
  overflow: auto;
}

@media (max-width: 768px) {
  .program-date {
    text-align: right;
    margin-bottom: -10px;
    float: none !important;
    display: block;
  }

  .search {
    flex-direction: column;
    align-items: stretch;
  }

  .search div {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>

<style lang="less">
#_holacon_programs {
  .program-header {
    margin-bottom: 10px;
    margin-top: 10px;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    grid-gap: 10px;
    width: 100%;

    .program-search {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
    }

    .program-select {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      .el-select {
        width: 100% !important;
      }
    }
  }

  .swiper-container {
    width: 100%;
  }
}

@media (max-width: 768px) {
  #_holacon_programs {
    padding: 0px;

    .program-header {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>

<style lang="less" scoped>
.passive {
  opacity: 0.3;
}
pre {
  overflow: auto;
  width: 100%;
}
@import (css) url("https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

#_holacon_programs {
  color: #2c3e50;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  .days .day {
    margin: 0;
    padding: 1em;
  }

  .day {
    font-weight: 600;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    float: left;
    min-width: 100px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    margin: 0;

    &.active {
      .title {
        color: white;
        background-color: #333;
      }
    }

    .title {
      font-size: 18px;
      width: 35px;
      height: 35px;
      display: flex;

      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: whitesmoke;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
    }

    .day-title {
      font-size: 12px;
      font-weight: 500;
    }
  }

  #_programs {
    margin-top: 16px;
    width: 100%;
    margin-left: 0;
    padding: 0;

    .section {
      color: white;
      .date {
        color: white;
        i {
          color: white !important;
        }
        span {
          color: white !important;
        }
      }
    }

    ._tile {
      padding: 10px 15px;
      background-color: white;
      width: 100%;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      cursor: pointer;
      list-style: none;
      margin: 0;
      box-sizing: border-box;
      margin: 5px 0px;
      border-radius: 12px;
      min-height: 56px;

      .title {
        line-height: 24px;

        font-weight: bold;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

.saloon-hover {
  &:hover {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
}

#frame {
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}
.date {
  font-size: 13px;
}

.speakers {
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap:5px;
  .speaker-photo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-size: cover;
    list-style: none;
    float: left;
    cursor: pointer;
    padding: 0;
  }
}
.dialogHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #03658c;
  border-radius: 2px;
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/Programs.vue